import React, { useState } from "react";
import { toast } from "sonner";
import { Megaphone, Trash2, Send } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import { ukDate } from "../../lib/dates";

export const TeamNotices = ({ team, reload }) => {
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const post = async () => {
    if (!body.trim()) return;
    setBusy(true);
    try { await api.post(`/portal/my-teams/${team.id}/notices`, { body: body.trim() }); setBody(""); toast.success("Notice posted"); reload(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const del = (id) => api.delete(`/portal/my-teams/${team.id}/notices/${id}`).then(() => { toast.success("Notice removed"); reload(); })
    .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));

  if (!team.can_manage && !team.notices.length) return null;
  return (
    <div className="mt-5" data-testid={`team-notices-${team.id}`}>
      <h3 className="font-semibold text-xs uppercase tracking-wider mb-2 flex items-center gap-1.5" style={{ color: "var(--sj-text-3)" }}><Megaphone className="h-4 w-4" /> Team notices</h3>
      {team.can_manage && (
        <div className="flex gap-2 mb-3">
          <textarea data-testid={`team-notice-input-${team.id}`} rows={2} maxLength={500} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Share a short update with your team…"
            className="flex-1 min-w-0 bg-[#EDF2F4] border border-[#EBE9E4] rounded-xl outline-none focus:ring-2 focus:ring-[#0B5E4E]/20 px-3 py-2 text-sm resize-none" />
          <button data-testid={`team-notice-post-${team.id}`} onClick={post} disabled={busy || !body.trim()} className="self-end inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold text-white disabled:opacity-50" style={{ background: "var(--sj-primary)" }}><Send className="h-4 w-4" /> Post</button>
        </div>
      )}
      {!team.notices.length && <p className="text-sm" style={{ color: "var(--sj-text-3)" }}>No notices yet.</p>}
      <div className="space-y-2">
        {team.notices.map((n) => (
          <div key={n.id} data-testid={`team-notice-${n.id}`} className="rounded-xl p-3 border-l-4" style={{ background: "#FEF6D8", borderColor: "#E0B100" }}>
            <div className="flex items-start gap-2">
              <p className="text-sm flex-1 whitespace-pre-wrap" style={{ color: "#3d3000" }}>{n.body}</p>
              {team.can_manage && <button data-testid={`team-notice-delete-${n.id}`} onClick={() => del(n.id)} title="Remove notice" className="p-1 rounded hover:bg-black/5 shrink-0" style={{ color: "#8a6a00" }}><Trash2 className="h-3.5 w-3.5" /></button>}
            </div>
            <div className="text-[11px] mt-1" style={{ color: "#8a6a00" }}>{n.author} · {ukDate(n.created_at)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
